import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appDesktop, appPhone, valleyDesktop, valleyPhone } from "../bridges/publicAssets";
import { usePublicPage } from "./usePublicPage";
import { homeVariant } from "./mode";
import { PublicFooter } from "./PublicFooter";
import { PublicIcon } from "./PublicIcon";
import { keyWords } from "./keyWords";
import { SiteHeader } from "./SiteHeader";
import s from "./site.module.scss";

/**
 * The home page "wow" (boards 313/314). Today's headline, subtitle, button and app picture, unchanged.
 * W1 "Cloud bank": a soft white cloud bank behind the words, no box. W2 "Morning sky": the sky brightened to a light band, words centred,
 * the app picture rising from the valley. Which one ships is `HOME_VARIANT` in mode.ts (both stay built until the owner picks).
 */
export const HomePage = () => {
  const { t } = useTranslation();
  const variant = homeVariant();
  usePublicPage();
  return (
    <div className={`cy-next cy-public ${s.home} ${variant === "W2" ? s.w2 : s.w1}`} data-variant={variant}>
      <picture>
        <source media="(min-width: 700px)" srcSet={valleyDesktop} />
        <img className={s.homeBg} src={valleyPhone} alt="" aria-hidden="true" />
      </picture>
      <SiteHeader quietCreate blessing />
      <main className={s.hero}>
        <div className={s.words}>
          <h1 className={s.headline}>{keyWords(t("first_page.hero_headline"), true)}</h1>
          <p className={s.subtitle}>{t("first_page.hero_subtitle")}</p>
          <Link to="/welcome" className={s.cta}>{t("first_page.get_started")}<span className={s.ctaGo}><PublicIcon name="arrow" size={24} strokeWidth={2.6} /></span></Link>
        </div>
        <picture className={s.mockup}>
          <source media="(min-width: 901px)" srcSet={appDesktop} />
          <img src={appPhone} alt="connectyid app map and outreach dashboard" />
        </picture>
      </main>
      <PublicFooter className={s.homeFooter} />
    </div>
  );
};
